import { RecordingQuality } from '../types/media.enums';
import { QualityPreset } from '../types/recordrtc.types';

// Quality presets
export const QUALITY_PRESETS: Record<RecordingQuality, QualityPreset> = {
  [RecordingQuality.LOW]: {
    videoBitsPerSecond: 250000, // 250kbps - mobile-friendly
    audioBitsPerSecond: 32000, // 32kbps
    frameRate: 15,
    dimensions: { width: 640, height: 480 },
  },
  [RecordingQuality.MEDIUM]: {
    videoBitsPerSecond: 500000, // 500kbps - balanced
    audioBitsPerSecond: 64000, // 64kbps
    frameRate: 24,
    dimensions: { width: 1280, height: 720 },
  },
  [RecordingQuality.HIGH]: {
    videoBitsPerSecond: 1000000, // 1Mbps - good quality
    audioBitsPerSecond: 128000, // 128kbps
    frameRate: 30,
    dimensions: { width: 1280, height: 720 },
  },
  [RecordingQuality.ULTRA]: {
    videoBitsPerSecond: 2500000, // 2.5Mbps - best quality
    audioBitsPerSecond: 192000, // 192kbps
    frameRate: 60,
    dimensions: { width: 1920, height: 1080 },
  },
};

// Mobile-optimized presets (lower bitrates for mobile devices)
export const MOBILE_QUALITY_PRESETS: Record<RecordingQuality, Partial<QualityPreset>> = {
  [RecordingQuality.LOW]: { videoBitsPerSecond: 150000, audioBitsPerSecond: 24000 },
  [RecordingQuality.MEDIUM]: { videoBitsPerSecond: 300000, audioBitsPerSecond: 48000 },
  [RecordingQuality.HIGH]: { videoBitsPerSecond: 600000, audioBitsPerSecond: 96000 },
  [RecordingQuality.ULTRA]: { videoBitsPerSecond: 1000000, audioBitsPerSecond: 128000 },
};
